import GLightbox from 'glightbox'

export default class Lightbox {
    constructor () {
        const lightboxEls = document.querySelectorAll('[data-featherlight], a[href$=".jpg"], a[href$=".png"], a[href$=".jpeg"], a[href$=".gif"]')
        for (const el of lightboxEls) {
            el.classList.add('glightbox')
        }
        GLightbox({
            selector: '.glightbox',
        })
    }
}